import httpApi from '@/utils/http-api'
import { api } from '@/config'

export default {
  saveNpsFeedback: (body) => {
    return httpApi.postDataViaApi({
      url: api.nps.saveNpsFeedback,
      body
    })
  },
  cancelNpsFeedback: (body) => {
    return httpApi.postDataViaApi({
      url: api.nps.cancelNpsFeedback,
      body
    })
  }
}
